<template>
  <v-container>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import  AppConfig   from "@/config/AppConfig";
import { bodyScript } from "@/common/helpers/helpers";

export default {
  computed: {
    ...mapGetters(["userProfile"])
  },
  mounted() {
    this.isLoaded = false;    
    this.loadChatbootSofia(true);    
  },
  data() {
    return {
      isLoaded: false
    };
  },
  methods: {
   loadChatbootSofia (loadScript){       
     if (loadScript)
      bodyScript(AppConfig.baseUrlChatbootSofia);     
      if (this.isLoaded){
        return;
      }     
      setTimeout(() => {     
        if (typeof sofi === "undefined"){
          this.loadChatbootSofia(false);          
          return;
        }
        let sofi_data = {
          code : 200,
          msg : "User profile",
          data: {
            appId: "5c33d14ecc761c4d05397c57",
            profile: this.userProfile,
            scope: ["aps_user", "user", "aps_admin", "aps_broker"]
          }
        };
        try{
          sofi.init(JSON.stringify(sofi_data));
          
          this.isLoaded = true;
        // eslint-disable-next-line no-empty
        }catch(err){
        }          
      }, 200);        
    }
  }
};
</script>
